<template>
  <div class="appointment-service">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link"  style="color: #3498db;">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
        </div>
    </header>

    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h1>预约服务</h1>
        <p>便捷在线预约，专业量子健康服务触手可及</p>
        <div class="header-features">
          <span><i class="el-icon-time"></i>24小时在线预约</span>
          <span><i class="el-icon-user"></i>专家团队服务</span>
          <span><i class="el-icon-check"></i>即时确认</span>
        </div>
      </div>
    </div>

    <!-- 预约流程 -->
    <div class="section process-section">
      <div class="container">
        <h2 class="section-title">预约流程</h2>
        <div class="process-steps">
          <div class="step" v-for="(step, index) in bookingSteps" :key="index">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-icon">
              <i :class="step.icon"></i>
            </div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务选择 -->
    <div class="section service-selection-section">
      <div class="container">
        <h2 class="section-title">选择服务</h2>
        <div class="service-categories">
          <button 
            v-for="category in serviceCategories" 
            :key="category.id"
            :class="{ active: selectedCategory === category.id }"
            @click="selectCategory(category.id)"
          >
            <i :class="category.icon"></i>
            {{ category.name }}
          </button>
        </div>
        <div class="services-grid">
          <div 
            class="service-card" 
            v-for="service in filteredServices" 
            :key="service.id"
            :class="{ selected: selectedService && selectedService.id === service.id }"
            @click="selectService(service)"
          >
            <div class="service-header">
              <div class="service-icon">
                <i :class="service.icon"></i>
              </div>
              <div class="service-price">
                <span class="price">¥{{ service.price }}</span>
                <span class="unit">{{ service.unit }}</span>
              </div>
            </div>
            <h3>{{ service.name }}</h3>
            <p>{{ service.description }}</p>
            <div class="service-duration">
              <i class="el-icon-time"></i>
              <span>服务时长：{{ service.duration }}</span>
            </div>
            <div class="service-features">
              <span v-for="feature in service.features" :key="feature">{{ feature }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 专家选择 -->
    <div class="section expert-selection-section" v-if="selectedService">
      <div class="container">
        <h2 class="section-title">选择专家</h2>
        <div class="experts-grid">
          <div 
            class="expert-card" 
            v-for="expert in experts" 
            :key="expert.id"
            :class="{ selected: selectedExpert && selectedExpert.id === expert.id }"
            @click="selectExpert(expert)"
          >
            <div class="expert-avatar">
              <img :src="expert.avatar" :alt="expert.name">
            </div>
            <div class="expert-info">
              <h3>{{ expert.name }}</h3>
              <p class="expert-title">{{ expert.title }}</p>
              <p class="expert-specialty">{{ expert.specialty }}</p>
              <div class="expert-rating">
                <el-rate v-model="expert.rating" disabled></el-rate>
                <span class="rating-text">{{ expert.rating }}分</span>
              </div>
              <div class="expert-badges">
                <span v-for="badge in expert.badges" :key="badge">{{ badge }}</span>
              </div>
            </div>
            <div class="expert-schedule">
              <h4>可预约时间</h4>
              <div class="schedule-tags">
                <span v-for="time in expert.availableTimes" :key="time">{{ time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 日期时间选择 -->
    <div class="section datetime-section" v-if="selectedExpert">
      <div class="container">
        <h2 class="section-title">选择时间</h2>
        <div class="datetime-content">
          <div class="calendar-section">
            <h3>选择日期</h3>
            <el-calendar v-model="selectedDate">
              <template slot="dateCell" slot-scope="{date, data}">
                <div 
                  :class="{
                    'calendar-date': true,
                    'selected': isSelectedDate(data.day),
                    'available': isDateAvailable(data.day),
                    'disabled': !isDateAvailable(data.day)
                  }"
                  @click="selectDate(data.day)"
                >
                  {{ data.day.split('-')[2] }}
                </div>
              </template>
            </el-calendar>
          </div>
          <div class="time-section">
            <h3>选择时间</h3>
            <div class="time-slots">
              <div 
                class="time-slot" 
                v-for="slot in availableTimeSlots" 
                :key="slot.time"
                :class="{ 
                  selected: selectedTimeSlot === slot.time,
                  disabled: !slot.available
                }"
                @click="selectTimeSlot(slot.time, slot.available)"
              >
                <span class="time">{{ slot.time }}</span>
                <span class="status">{{ slot.status }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约信息填写 -->
    <div class="section booking-form-section" v-if="selectedTimeSlot">
      <div class="container">
        <h2 class="section-title">填写预约信息</h2>
        <div class="booking-form-content">
          <div class="appointment-summary">
            <h3>预约信息确认</h3>
            <div class="summary-item">
              <span class="label">服务项目：</span>
              <span class="value">{{ selectedService.name }}</span>
            </div>
            <div class="summary-item">
              <span class="label">服务专家：</span>
              <span class="value">{{ selectedExpert.name }} - {{ selectedExpert.title }}</span>
            </div>
            <div class="summary-item">
              <span class="label">预约时间：</span>
              <span class="value">{{ formatDate(selectedDate) }} {{ selectedTimeSlot }}</span>
            </div>
            <div class="summary-item">
              <span class="label">服务时长：</span>
              <span class="value">{{ selectedService.duration }}</span>
            </div>
            <div class="summary-item">
              <span class="label">服务费用：</span>
              <span class="value price">¥{{ selectedService.price }}</span>
            </div>
          </div>
          <div class="personal-form">
            <el-form :model="bookingForm" :rules="bookingRules" ref="bookingForm" label-width="100px" class="booking-form">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="bookingForm.name" placeholder="请输入您的真实姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="bookingForm.gender">
                  <el-radio label="male">男</el-radio>
                  <el-radio label="female">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="年龄" prop="age">
                <el-input-number v-model="bookingForm.age" :min="1" :max="120" placeholder="请输入年龄"></el-input-number>
              </el-form-item>
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="bookingForm.phone" placeholder="请输入手机号码"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="bookingForm.idCard" placeholder="请输入身份证号码"></el-input>
              </el-form-item>
              <el-form-item label="健康状况" prop="healthStatus">
                <el-select v-model="bookingForm.healthStatus" placeholder="请选择健康状况">
                  <el-option label="健康" value="healthy"></el-option>
                  <el-option label="亚健康" value="subhealthy"></el-option>
                  <el-option label="有慢性疾病" value="chronic"></el-option>
                  <el-option label="其他" value="other"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="过敏史" prop="allergies">
                <el-input v-model="bookingForm.allergies" placeholder="请描述过敏史，如无请填无"></el-input>
              </el-form-item>
              <el-form-item label="主要症状" prop="symptoms">
                <el-input type="textarea" v-model="bookingForm.symptoms" :rows="3" placeholder="请简要描述您的身体状况或需要调理的问题"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="notes">
                <el-input type="textarea" v-model="bookingForm.notes" :rows="2" placeholder="其他需要说明的事项"></el-input>
              </el-form-item>
              <el-form-item label="支付方式" prop="paymentMethod">
                <el-radio-group v-model="bookingForm.paymentMethod">
                  <el-radio label="wechat">微信支付</el-radio>
                  <el-radio label="alipay">支付宝</el-radio>
                  <el-radio label="card">银行卡</el-radio>
                  <el-radio label="cash">到店支付</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 提交预约 -->
    <div class="section submit-section" v-if="selectedTimeSlot">
      <div class="container">
        <div class="submit-content">
          <div class="terms-section">
            <el-checkbox v-model="agreeTerms">我已阅读并同意</el-checkbox>
            <a href="#" @click.prevent="showTerms">《服务条款》</a>
            <span>和</span>
            <a href="#" @click.prevent="showPrivacy">《隐私政策》</a>
          </div>
          <div class="submit-buttons">
            <el-button size="large" @click="resetBooking">重新选择</el-button>
            <el-button type="primary" size="large" @click="submitBooking" :disabled="!agreeTerms">提交预约</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约须知 -->
    <div class="section notice-section">
      <div class="container">
        <h2 class="section-title">预约须知</h2>
        <div class="notice-content">
          <div class="notice-item">
            <h3><i class="el-icon-time"></i>预约时间</h3>
            <ul>
              <li>请至少提前24小时预约服务</li>
              <li>预约成功后，我们会发送确认短信</li>
              <li>如需修改或取消预约，请提前6小时通知</li>
              <li>迟到超过15分钟，预约可能被取消</li>
            </ul>
          </div>
          <div class="notice-item">
            <h3><i class="el-icon-user"></i>到店须知</h3>
            <ul>
              <li>请携带有效身份证件</li>
              <li>建议穿着宽松舒适的服装</li>
              <li>服务前避免过量饮食和饮酒</li>
              <li>如有特殊情况，请提前告知工作人员</li>
            </ul>
          </div>
          <div class="notice-item">
            <h3><i class="el-icon-warning"></i>注意事项</h3>
            <ul>
              <li>孕妇、心脏病患者等特殊人群请先咨询医生</li>
              <li>服务过程中如感不适，请立即告知工作人员</li>
              <li>禁止在醉酒状态下接受服务</li>
              <li>请如实填写健康状况，确保服务安全</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系客服 -->
    <!-- <div class="section contact-section">
      <div class="container">
        <h2 class="section-title">需要帮助？</h2>
        <div class="contact-options">
          <div class="contact-card">
            <div class="contact-icon">
              <i class="el-icon-phone"></i>
            </div>
            <h3>电话预约</h3>
            <p>400-888-9999</p>
            <span>工作时间：9:00-21:00</span>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <h3>在线客服</h3>
            <p>7×24小时在线</p>
            <el-button type="primary" @click="startChat">开始咨询</el-button>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <i class="el-icon-location"></i>
            </div>
            <h3>到店预约</h3>
            <p>北京市海淀区中关村科技园</p>
            <el-button type="primary" @click="showMap">查看地图</el-button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 页面底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关于我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;" @click=" window.open('https://beian.miit.gov.cn/', '_blank', 'noopener noreferrer');">© 2026 北京和合网链科技发展有限公司 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AppointmentService',
  data() {
    return {
      selectedCategory: 'all',
      selectedService: null,
      selectedExpert: null,
      selectedDate: new Date(),
      selectedTimeSlot: null,
      agreeTerms: false,
      bookingSteps: [
        {
          icon: 'el-icon-menu',
          title: '选择服务',
          description: '选择您需要的量子健康服务项目'
        },
        {
          icon: 'el-icon-user-solid',
          title: '选择专家',
          description: '选择合适的专业服务专家'
        },
        {
          icon: 'el-icon-date',
          title: '选择时间',
          description: '选择方便的预约时间'
        },
        {
          icon: 'el-icon-edit',
          title: '填写信息',
          description: '完善个人信息和健康状况'
        },
        {
          icon: 'el-icon-check',
          title: '确认预约',
          description: '提交预约并等待确认'
        }
      ],
      serviceCategories: [
        { id: 'all', name: '全部服务', icon: 'el-icon-menu' },
        { id: 'detection', name: '健康检测', icon: 'el-icon-search' },
        { id: 'conditioning', name: '量子调理', icon: 'el-icon-magic-stick' },
        { id: 'management', name: '健康管理', icon: 'el-icon-data-analysis' },
        { id: 'consultation', name: '专家咨询', icon: 'el-icon-user' }
      ],
      services: [
        {
          id: 1,
          name: '量子全身健康检测',
          description: '全面检测身体健康状况，精准评估健康风险',
          price: 299,
          unit: '次',
          duration: '60分钟',
          category: 'detection',
          icon: 'el-icon-search',
          features: ['全身检测', '风险评估', '健康报告']
        },
        {
          id: 2,
          name: '量子能量调理',
          description: '调节身体能量场，恢复生命活力',
          price: 399,
          unit: '次',
          duration: '90分钟',
          category: 'conditioning',
          icon: 'el-icon-magic-stick',
          features: ['能量调节', '经络疏通', '气血调理']
        },
        {
          id: 3,
          name: '个性化健康管理',
          description: '制定专属健康管理方案，全程跟踪指导',
          price: 1299,
          unit: '月',
          duration: '按月服务',
          category: 'management',
          icon: 'el-icon-data-analysis',
          features: ['个性方案', '跟踪指导', '效果评估']
        },
        {
          id: 4,
          name: '专家一对一咨询',
          description: '资深专家面对面咨询，解答健康疑问',
          price: 199,
          unit: '次',
          duration: '30分钟',
          category: 'consultation',
          icon: 'el-icon-user',
          features: ['专家咨询', '健康建议', '方案指导']
        }
      ],
      experts: [
        {
          id: 1,
          name: '张医生',
          title: '首席量子健康专家',
          specialty: '量子检测与调理',
          avatar: '/api/placeholder/80/80',
          rating: 4.9,
          badges: ['10年经验', '认证专家'],
          availableTimes: ['周一至周五', '周末上午']
        },
        {
          id: 2,
          name: '李医生',
          title: '高级健康管理师',
          specialty: '慢性病管理',
          avatar: '/api/placeholder/80/80',
          rating: 4.8,
          badges: ['8年经验', '营养专家'],
          availableTimes: ['周二至周四', '周六全天']
        },
        {
          id: 3,
          name: '王医生',
          title: '量子调理专家',
          specialty: '疼痛管理',
          avatar: '/api/placeholder/80/80',
          rating: 4.7,
          badges: ['6年经验', '康复专家'],
          availableTimes: ['周一、三、五', '周日全天']
        }
      ],
      availableTimeSlots: [
        { time: '09:00', available: true, status: '可预约' },
        { time: '09:30', available: false, status: '已约满' },
        { time: '10:00', available: true, status: '可预约' },
        { time: '10:30', available: true, status: '可预约' },
        { time: '11:00', available: false, status: '已约满' },
        { time: '11:30', available: true, status: '可预约' },
        { time: '14:00', available: true, status: '可预约' },
        { time: '14:30', available: false, status: '已约满' },
        { time: '15:00', available: true, status: '可预约' },
        { time: '15:30', available: true, status: '可预约' },
        { time: '16:00', available: false, status: '已约满' },
        { time: '16:30', available: true, status: '可预约' }
      ],
      bookingForm: {
        name: '',
        gender: '',
        age: null,
        phone: '',
        idCard: '',
        healthStatus: '',
        allergies: '',
        symptoms: '',
        notes: '',
        paymentMethod: 'wechat'
      },
      bookingRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请输入年龄', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号码', trigger: 'blur' }
        ],
        healthStatus: [
          { required: true, message: '请选择健康状况', trigger: 'change' }
        ],
        symptoms: [
          { required: true, message: '请描述主要症状', trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      },
      // 导航栏相关数据
      phone: '',
      login: false,
      feedBack: false,
      reservationConditioning: false
    }
  },
  computed: {
    filteredServices() {
      if (this.selectedCategory === 'all') {
        return this.services
      }
      return this.services.filter(service => service.category === this.selectedCategory)
    }
  },
  methods: {
    selectCategory(categoryId) {
      this.selectedCategory = categoryId
      this.selectedService = null
      this.selectedExpert = null
      this.selectedTimeSlot = null
    },
    selectService(service) {
      this.selectedService = service
      this.selectedExpert = null
      this.selectedTimeSlot = null
    },
    selectExpert(expert) {
      this.selectedExpert = expert
      this.selectedTimeSlot = null
    },
    isSelectedDate(day) {
      return this.formatDate(this.selectedDate) === day
    },
    isDateAvailable(day) {
      const date = new Date(day)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date >= today && date.getDay() !== 0 // 简单示例：周日不开放
    },
    selectDate(day) {
      if (this.isDateAvailable(day)) {
        this.selectedDate = new Date(day)
        this.selectedTimeSlot = null
      }
    },
    selectTimeSlot(time, available) {
      if (available) {
        this.selectedTimeSlot = time
      }
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    submitBooking() {
      this.$refs.bookingForm.validate((valid) => {
        if (valid) {
          this.$message.success('预约提交成功！我们会尽快与您联系确认。')
          // 这里可以跳转到预约成功页面
        } else {
          this.$message.error('请完善预约信息')
          return false
        }
      })
    },
    resetBooking() {
      this.selectedService = null
      this.selectedExpert = null
      this.selectedTimeSlot = null
      this.agreeTerms = false
      this.$refs.bookingForm.resetFields()
    },
    showTerms() {
      this.$message.info('显示服务条款')
    },
    showPrivacy() {
      this.$message.info('显示隐私政策')
    },
    startChat() {
      this.$message.info('启动在线客服')
    },
    showMap() {
      this.$message.info('显示地图位置')
    },
    
    // 导航栏相关方法
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('查看检测结果功能')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

.appointment-service {
  padding-top: 80px;
}

.page-header {
  background: linear-gradient(135deg, #1890FF 0%, #00D4FF 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
}

.header-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  font-weight: 600;
}

.header-content p {
  font-size: 20px;
  margin-bottom: 30px;
  opacity: 0.9;
}

.header-features {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.header-features span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}

.section {
  padding: 80px 0;
}

.section:nth-child(even) {
  background: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  margin-bottom: 60px;
  color: #333;
  font-weight: 600;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
}

.step {
  text-align: center;
  position: relative;
}

.step-number {
  width: 40px;
  height: 40px;
  background: #1890FF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  margin: 0 auto 20px;
}

.step-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.step-icon i {
  font-size: 32px;
  color: white;
}

.step h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.step p {
  color: #666;
  line-height: 1.6;
}

.service-categories {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.service-categories button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: 2px solid #e0e0e0;
  background: white;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.service-categories button.active,
.service-categories button:hover {
  border-color: #1890FF;
  background: #1890FF;
  color: white;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.service-card:hover,
.service-card.selected {
  border-color: #1890FF;
  transform: translateY(-5px);
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.service-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-icon i {
  font-size: 28px;
  color: white;
}

.service-price {
  text-align: right;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #1890FF;
}

.unit {
  font-size: 14px;
  color: #666;
  margin-left: 5px;
}

.service-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.service-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-duration {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  color: #666;
}

.service-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.service-features span {
  background: #f0f8ff;
  color: #1890FF;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
}

.experts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
}

.expert-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.expert-card:hover,
.expert-card.selected {
  border-color: #1890FF;
  transform: translateY(-5px);
}

.expert-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
}

.expert-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.expert-info {
  text-align: center;
  margin-bottom: 20px;
}

.expert-info h3 {
  font-size: 20px;
  margin-bottom: 5px;
  color: #333;
}

.expert-title {
  color: #1890FF;
  font-weight: 500;
  margin-bottom: 5px;
}

.expert-specialty {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}

.expert-rating {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 15px;
}

.rating-text {
  font-size: 14px;
  color: #666;
}

.expert-badges {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.expert-badges span {
  background: #f0f8ff;
  color: #1890FF;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.expert-schedule {
  text-align: center;
}

.expert-schedule h4 {
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
}

.schedule-tags {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.schedule-tags span {
  background: #f8f9fa;
  color: #666;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.datetime-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

.calendar-section h3,
.time-section h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
}

.calendar-date {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.calendar-date.selected {
  background: #1890FF;
  color: white;
}

.calendar-date.available:hover {
  background: #f0f8ff;
}

.calendar-date.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.time-slots {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.time-slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.time-slot:hover,
.time-slot.selected {
  border-color: #1890FF;
  background: #f0f8ff;
}

.time-slot.disabled {
  background: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
  border-color: #e0e0e0;
}

.time {
  font-weight: 500;
  color: #333;
}

.status {
  font-size: 12px;
  color: #666;
}

/* 统一表单元素大小 */
.booking-form .el-input__inner {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.booking-form .el-select {
  width: 100%;
}

.booking-form .el-select .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.booking-form .el-select .el-input {
  height: 40px;
}

.booking-form .el-input-number {
  width: 100%;
}

.booking-form .el-input-number .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.booking-form .el-textarea__inner {
  font-size: 14px;
  line-height: 1.5;
}

.booking-form .el-form-item__label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.booking-form .el-button {
  height: 40px;
  padding: 0 20px;
  font-size: 14px;
}

.booking-form-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
}

.appointment-summary {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.appointment-summary h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.summary-item:last-child {
  border-bottom: none;
}

.label {
  color: #666;
}

.value {
  color: #333;
  font-weight: 500;
}

.value.price {
  color: #1890FF;
  font-size: 18px;
  font-weight: bold;
}

.personal-form {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.submit-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.terms-section {
  margin-bottom: 30px;
}

.terms-section a {
  color: #1890FF;
  text-decoration: none;
}

.submit-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.submit-buttons .el-button {
  min-width: 150px;
}

.notice-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.notice-item {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.notice-item h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
}

.notice-item h3 i {
  color: #1890FF;
}

.notice-item ul {
  list-style: none;
  padding: 0;
}

.notice-item li {
  padding: 8px 0;
  color: #666;
  position: relative;
  padding-left: 20px;
}

.notice-item li:before {
  content: "•";
  color: #1890FF;
  position: absolute;
  left: 0;
  font-weight: bold;
}

.contact-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.contact-card {
  background: white;
  padding: 40px 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  text-align: center;
}

.contact-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.contact-icon i {
  font-size: 32px;
  color: white;
}

.contact-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.contact-card p {
  font-size: 18px;
  color: #1890FF;
  font-weight: 500;
  margin-bottom: 10px;
}

.contact-card span {
  font-size: 14px;
  color: #666;
  display: block;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .header-content h1 {
    font-size: 32px;
  }
  
  .header-features {
    flex-direction: column;
    gap: 15px;
  }
  
  .process-steps {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
  }
  
  .datetime-content,
  .booking-form-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .services-grid,
  .experts-grid {
    grid-template-columns: 1fr;
  }
  
  .time-slots {
    grid-template-columns: 1fr;
  }
  
  .notice-content,
  .contact-options {
    grid-template-columns: 1fr;
  }
}

/* 页面底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}
</style>